// 首页楼层
const api = {
  // 轮询查看用户登录状态
  checkLoginStatus: {
    url: '/userauth/caLogin/verifyQrCode',
    type: 'post'
  },
  // 查询登录二维码code
  getLoginCode: {
    url: '/userauth/caLogin/getQrcode',
    type: 'get'
  },
  // 商城公共头部、底部、购物车数量、当前地址等公共信息
  homeBasic: {
    url: '/mall/home/base',
    type: 'post',
    parameter: {
      set: Array,
      pageCode: Number
    }
  },
  // 首页轮播图
  getImage: {
    url: '/staff_mall/advertisingManage/getImage',
    type: 'get',
    parameter: {}
  },
  // 获取商品范围查询条件
  querySearchParam: {
    url: '/staff_mall/pageMallSku/querySearchParam',
    type: 'post',
    parameter: {}
  },
  // 首页查询获取楼层部分基础数据
  floorBase: {
    url: '/staff_mall/portal/floor/base',
    type: 'post',
    parameter: {}
  },
  // 首页基本信息查询
  homeBase: {
    url: '/staff_mall/home/base',
    type: 'post',
    parameter: {}
  },
  // 页面名称获取
  pageName: {
    url: '/staff_mall/home/pageName',
    type: 'post',
    parameter: {}
  },
  // 页面配置查询 根据code查询
  pageGet: {
    url: '/staff_mall/page/get',
    type: 'post',
    parameter: {}
  },
  // 修改城市选择
  setSite: {
    url: '/staff_mall/site/setSite',
    type: 'get',
    parameter: {}
  },
  // 获取城市选择
  getSite: {
    url: '/staff_mall/site/getSite',
    type: 'get',
    parameter: {}
  }
}

export default api



// WEBPACK FOOTER //
// ./src/api/home.js